import { render } from "./NavbarNotification.vue?vue&type=template&id=32249668&scoped=true"
import script from "./NavbarNotification.vue?vue&type=script&lang=js"
export * from "./NavbarNotification.vue?vue&type=script&lang=js"

import "./NavbarNotification.vue?vue&type=style&index=0&id=32249668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32249668"]])

export default __exports__